import { Outlet } from "react-router-dom";
import { EntityReplaceModel } from "../../entities/common";
import { IndexPageHeaderWithReplace } from "./IndexPageHeaderWithReplaceProps";
import { memo } from "react";

interface DefaultIndexWithReplaceProps {
  title: string;
  query: Function;
  replaceMutation: Function;
  replacer: (replacerCallback: (data: EntityReplaceModel) => Promise<boolean>) => JSX.Element;
}

const DefaultIndexWithReplace = memo(({ title, query, replaceMutation, replacer }: DefaultIndexWithReplaceProps) => {
  return (
    <div>
      <IndexPageHeaderWithReplace title={title} query={query} replaceMutation={replaceMutation} replacer={replacer} />
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
});

export const GetDefaultIndexWithReplace =
  ({ title, query, replaceMutation, replacer }: DefaultIndexWithReplaceProps) =>
  () =>
    <DefaultIndexWithReplace title={title} query={query} replaceMutation={replaceMutation} replacer={replacer} />;
